import { Content } from "./components/content/content";
import { Label } from "./components/label/label";
import { Base } from "./guaranteeNotice.base";

export const GuaranteeNotice = Object.assign(Base, {
    Label: Label,
    Content: Content
});
